import { render, staticRenderFns } from "./PhysEquipment.vue?vue&type=template&id=5123d798&scoped=true"
import script from "./PhysEquipment.vue?vue&type=script&lang=js"
export * from "./PhysEquipment.vue?vue&type=script&lang=js"
import style0 from "./PhysEquipment.vue?vue&type=style&index=0&id=5123d798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123d798",
  null
  
)

export default component.exports